export default "__VITE_PUBLIC_ASSET__27b5b411__"